export default __webpack_public_path__ + "static/media/Boots of Bone and Horn.28bfe756.jpg";